function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import PinInput from 'react-pin-input';
/**
 * @type {React.FC<{
 * inputStyle?: object;
 * onComplete?: (pin: string) => void;
 * }>}
 */ var PinField = /*#__PURE__*/ forwardRef(function(param, ref) {
    var onComplete = param.onComplete, _param_inputStyle = param.inputStyle, inputStyle = _param_inputStyle === void 0 ? {} : _param_inputStyle;
    var settings = {
        inputStyle: _object_spread({
            borderRadius: '4px',
            fontSize: '19px',
            color: '#677882',
            fontWeight: 'bold',
            height: '45px',
            width: '40px',
            marginLeft: '5px',
            marginRight: '5px',
            paddingTop: '2px',
            paddingLeft: '2px',
            border: '1px solid #BCCAD2'
        }, inputStyle),
        inputFocusStyle: {
            border: '1px solid #4C94D7',
            boxShadow: '0px 1px 6px rgba(11, 153, 230, 0.4)'
        }
    };
    return /*#__PURE__*/ _jsx(PinInput, _object_spread({
        length: 4,
        focus: true,
        type: "numeric",
        pattern: "[0-9]*",
        inputMode: "number",
        autocomplete: "one-time-code",
        id: "alpineIqPinInput",
        ref: ref,
        onComplete: function(value, _) {
            onComplete(value);
        }
    }, settings));
});
export default PinField;
